"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var rxjs_1 = require("rxjs");
var errors_1 = require("@ledgerhq/errors");
var operation_1 = require("../../operation");
var hw_app_celo_1 = require("./hw-app-celo");
var js_buildTransaction_1 = __importDefault(require("./js-buildTransaction"));
var wallet_base_1 = require("@celo/wallet-base");
var tokens_1 = require("@celo/wallet-ledger/lib/tokens");
var deviceAccess_1 = require("../../hw/deviceAccess");
var MODE_TO_TYPE = {
    send: "OUT",
    lock: "LOCK",
    unlock: "UNLOCK",
    withdraw: "WITHDRAW",
    vote: "VOTE",
    revoke: "REVOKE",
    activate: "ACTIVATE",
    register: "REGISTER",
    "default": "FEE"
};
var buildOptimisticOperation = function (account, transaction, fee) {
    var _a;
    var type = ((_a = MODE_TO_TYPE[transaction.mode]) !== null && _a !== void 0 ? _a : MODE_TO_TYPE["default"]);
    var value = type === "OUT" || type === "LOCK"
        ? new bignumber_js_1.BigNumber(transaction.amount).plus(fee)
        : new bignumber_js_1.BigNumber(transaction.amount);
    var operation = {
        id: (0, operation_1.encodeOperationId)(account.id, "", type),
        hash: "",
        type: type,
        value: value,
        fee: fee,
        blockHash: null,
        blockHeight: null,
        senders: [account.freshAddress],
        recipients: [transaction.recipient].filter(Boolean),
        accountId: account.id,
        date: new Date(),
        extra: {}
    };
    return operation;
};
var trimLeading0x = function (input) {
    return input.startsWith("0x") ? input.slice(2) : input;
};
var parseSigningResponse = function (response, chainId) {
    // EIP155
    var sigV = parseInt(response.v, 16);
    var eip155V = chainId * 2 + 35;
    if (sigV !== eip155V && (sigV & eip155V) !== sigV) {
        eip155V += 1;
    }
    return {
        s: Buffer.from(response.s, "hex"),
        v: eip155V,
        r: Buffer.from(response.r, "hex")
    };
};
/**
 * Sign Transaction with Ledger hardware
 */
var signOperation = function (_a) {
    var account = _a.account, deviceId = _a.deviceId, transaction = _a.transaction;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return new rxjs_1.Observable(function (o) {
            var cancelled;
            function main() {
                var _a;
                return __awaiter(this, void 0, void 0, function () {
                    var celo, unsignedTransaction, chainId, to, rlpEncodedTransaction, tokenInfo, response, signature, encodedTransaction, operation;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!transaction.fees) {
                                    throw new errors_1.FeeNotLoaded();
                                }
                                celo = new hw_app_celo_1.CeloApp(transport);
                                return [4 /*yield*/, (0, js_buildTransaction_1["default"])(account, transaction)];
                            case 1:
                                unsignedTransaction = _b.sent();
                                chainId = unsignedTransaction.chainId, to = unsignedTransaction.to;
                                rlpEncodedTransaction = (0, wallet_base_1.rlpEncodedTx)(unsignedTransaction);
                                tokenInfo = (0, tokens_1.tokenInfoByAddressAndChainId)(to, chainId);
                                if (!tokenInfo) return [3 /*break*/, 3];
                                return [4 /*yield*/, celo.provideERC20TokenInformation(tokenInfo)];
                            case 2:
                                _b.sent();
                                _b.label = 3;
                            case 3:
                                o.next({ type: "device-signature-requested" });
                                return [4 /*yield*/, celo.signTransaction(account.freshAddressPath, trimLeading0x(rlpEncodedTransaction.rlpEncode))];
                            case 4:
                                response = _b.sent();
                                if (cancelled)
                                    return [2 /*return*/];
                                signature = parseSigningResponse(response, chainId);
                                o.next({ type: "device-signature-granted" });
                                return [4 /*yield*/, (0, wallet_base_1.encodeTransaction)(rlpEncodedTransaction, signature)];
                            case 5:
                                encodedTransaction = _b.sent();
                                operation = buildOptimisticOperation(account, transaction, (_a = transaction.fees) !== null && _a !== void 0 ? _a : new bignumber_js_1.BigNumber(0));
                                o.next({
                                    type: "signed",
                                    signedOperation: {
                                        operation: operation,
                                        signature: encodedTransaction.raw,
                                        expirationDate: null
                                    }
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            }
            main().then(function () { return o.complete(); }, function (e) { return o.error(e); });
            return function () {
                cancelled = true;
            };
        });
    });
};
exports["default"] = signOperation;
//# sourceMappingURL=js-signOperation.js.map